module.exports = __webpack_public_path__ + "static/IBMPlexSans-Light-e03c273c0021a6da5e0d7b8b4fdf8429.woff";